import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { actions as storesActions } from 'app/main/apps/stores/ducks/stores.slice';

export type NavigationBadgeScope = 'store' | 'franchise';

export type NavigationBadge = {
  title?: string;
  bg?: string;
  fg?: string;
  iconTitle?: string;
  scope?: NavigationBadgeScope;
};

export type NavigationBadgesState = Record<string, NavigationBadge>;

const initialState: NavigationBadgesState = {};

const navigationBadgesSlice = createSlice({
  name: 'navigationBadges',
  initialState,
  reducers: {
    setNavigationBadge: (state, action: PayloadAction<{ id: string; badge: NavigationBadge }>) => {
      state[action.payload.id] = action.payload.badge;
    },
    clearNavigationBadge: (state, action: PayloadAction<string>) => {
      delete state[action.payload];
    },
  },
  extraReducers: builder => {
    // Store-scoped badges (the default) count something of the selected store, so they do not survive a switch;
    // franchise-scoped ones do not depend on the store.
    builder.addCase(storesActions.setCurrentStoreId, state =>
      Object.fromEntries(Object.entries(state).filter(([, badge]) => badge.scope === 'franchise')),
    );
  },
});

export const { setNavigationBadge, clearNavigationBadge } = navigationBadgesSlice.actions;

export default navigationBadgesSlice.reducer;
